import {
  ParagraphContentOverview,
  ParagraphFAQ,
  ParagraphContentSelection,
  ParagraphImageTicker,
  ParagraphLinkList,
  ParagraphPracticalInformation,
  ParagraphQuote,
  ParagraphText,
  ParagraphTextImageGrid,
  ParagraphTextMedia,
  ParagraphWebform,
} from '../implementations';

const mappers = {
  content_overview: ParagraphContentOverview,
  faq: ParagraphFAQ,
  highlighted_selection: ParagraphContentSelection,
  image_ticker: ParagraphImageTicker,
  link_list: ParagraphLinkList,
  practical_information: ParagraphPracticalInformation,
  quote: ParagraphQuote,
  text_image_grid: ParagraphTextImageGrid,
  text_media: ParagraphTextMedia,
  text: ParagraphText,
  webform_wrapper: ParagraphWebform,
};

export default mappers;
